module.exports = __webpack_public_path__ + "static/fonts/Montserrat-Regular.2b1160e.woff2";